"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAttachmentContainer = exports.StyledMessageHeader = exports.StyledUnderlinedText = exports.StyledMessageInfoContainer = exports.StyledSpinner = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../../../../styles/tokens");
const StackPanel_1 = require("../../../../../Layout/StackPanel/StackPanel");
const Spinner_1 = require("../../../../../Spinner/Spinner");
exports.StyledSpinner = (0, styled_components_1.default)(Spinner_1.Spinner) `
    margin-right: ${tokens_1.SIZES[0.5]};
`;
exports.StyledMessageInfoContainer = styled_components_1.default.div `
    display: flex;
    justify-content: space-between;
    padding: 0 ${tokens_1.SIZES[2]} ${tokens_1.SIZES[0.5]};
`;
exports.StyledUnderlinedText = styled_components_1.default.span `
    text-decoration: underline;
`;
exports.StyledMessageHeader = styled_components_1.default.div `
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: ${tokens_1.SIZES[1]};
    padding: ${tokens_1.SIZES[2]} ${tokens_1.SIZES[2]} 0;
`;
exports.StyledAttachmentContainer = (0, styled_components_1.default)(StackPanel_1.StackPanel) `
    padding: 0 ${tokens_1.SIZES[2]} ${tokens_1.SIZES[2]};
`;
//# sourceMappingURL=Message.styles.js.map